import Vue from 'vue'

export default {
  // 合同审批
  auditContract (data, cb, errorCb) {
    Vue.http.post('rest/api/audit', data).then(res => {
      var data = res['data']
      if (data['ok']) {
        cb()
      } else {
        errorCb(data['msg'])
      }
    }).catch(err => {
      errorCb('网络请求出错')
      console.dir(err)
    })
  },
  // 获取合同详情
  getContract (id, data, cb, errorCb) {
    Vue.http.post('rest/api/show/' + id, data).then(res => {
      var data = res['data']
      if (data['ok']) {
        cb(data['contract'])
      } else {
        errorCb(data['msg'])
      }
    }).catch(err => {
      errorCb('网络请求出错')
      console.dir(err)
    })
  },
  // 合同审批
  auditSealOut (data, cb, errorCb) {
    Vue.http.post('rest/api/auditSealOut', data).then(res => {
      var data = res['data']
      if (data['ok']) {
        cb()
      } else {
        errorCb(data['msg'])
      }
    }).catch(err => {
      errorCb('网络请求出错')
      console.dir(err)
    })
  },
  // 获取合同详情
  getSealOut (id, data, cb, errorCb) {
    Vue.http.post('rest/api/showSealOut/' + id, data).then(res => {
      var data = res['data']
      if (data['ok']) {
        cb(data['sealOut'])
      } else {
        errorCb(data['msg'])
      }
    }).catch(err => {
      errorCb('网络请求出错')
      console.dir(err)
    })
  },
  // 获取合同的所有附件
  getAttachments (id, cb, errorCb) {
    Vue.http.get('rest/api/attachMent', {
      params: {
        'contractId': id
      }
    }).then(res => {
      var data = res['data']
      if (data['ok']) {
        cb(data['data'])
      } else {
        errorCb(data['msg'])
      }
    }).catch(err => {
      errorCb('网络请求出错')
      console.dir(err)
    })
  },
  // 获取所有部门信息
  getAllDepartment (cb, errorCb) {
    Vue.http.get('rest/api/allDepartment').then(res => {
      var data = res['data']
      cb(data)
    }).catch(err => {
      errorCb('网络请求出错')
      console.dir(err)
    })
  },
  // 获取所有公司信息
  getAllCompany (cb, errorCb) {
    Vue.http.get('rest/api/allCompany').then(res => {
      var data = res['data']
      cb(data)
    }).catch(err => {
      errorCb('网络请求出错')
      console.dir(err)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/contractApi.js